import { useQuery } from "@tanstack/react-query";
import { clientAPI } from "../../api/client";

async function fetchConstantData(saleAreaId, projectId, department) {
  const searchOptions = {
    limit: 10000000,
    page: 1,
  };

  // if (projectId){
  //   searchOptions.status = 'OPEN';
  // }
  const searchQueryParams = new URLSearchParams(searchOptions).toString();
  let searchQueryEmployeeDepartment = new URLSearchParams(
    searchOptions
  ).toString();

  if (department) {
    searchQueryEmployeeDepartment =
      searchQueryParams + "&" + new URLSearchParams({ department }).toString();
  }
  // Fetch constant data concurrently
  const [
    project,
    apartment,
    customer,
    employeeDepartMent,
    employee,
    saleArea,
    saleBlock,
    saleOpeningEvent,
  ] = await Promise.all([
    clientAPI("get", `/project?${searchQueryParams}`),
    clientAPI("get", `/apartment?${searchQueryParams}`),
    clientAPI("get", `/customer?${searchQueryParams}`),
    clientAPI("get", `/employee?${searchQueryEmployeeDepartment}`),
    clientAPI("get", `/employee?${searchQueryParams}`),
    clientAPI("get", `/saleArea?${searchQueryParams}`),
    clientAPI("get", `/saleBlock?${searchQueryParams}`),
    clientAPI("get", `/saleOpeningEvent?${searchQueryParams}`),
  ]);

  // Index data by 'id' to improve lookup performance
  return {
    project: project?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.name }),
      {}
    ),
    apartment: apartment?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.name }),
      {}
    ),
    apartments: apartment?.items?.reduce(
      (acc, item) => ({
        ...acc,
        [item._id]: `${item.code} (${item.name})`,
      }),
      {}
    ),

    customer: customer?.items?.reduce(
      (acc, item) => ({
        ...acc,
        [item._id]: {
          fullName: item.name,
          code: item.code,
          phone: item.phone,
          identificationNumber: item.identificationNumber,
        },
      }),
      {}
    ),
    employeeDepartMent: employeeDepartMent?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.fullName }),
      {}
    ),
    employee: employee?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.fullName }),
      {}
    ),
    saleArea: saleArea?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.name }),
      {}
    ),
    saleBlock: saleBlock?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.name }),
      {}
    ),
    saleOpeningEvent: saleOpeningEvent?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.name }),
      {}
    ),
  };
}

export function useCategories(saleAreaId, projectId, department, shouldFetch) {
  // Fetch constant data once
  const {
    data: constantData,
    isLoading,
    isFetching,
    refetch,
  } = useQuery({
    queryKey: ["categories19"],
    queryFn: () => fetchConstantData(saleAreaId, projectId, department),
    enabled: shouldFetch,
    refetchOnWindowFocus: false,
  });

  return {
    constantData,
    isLoading,
    isFetching,
    refetch,
  };
}
